module.exports = __webpack_public_path__ + "static/contact@2x-9fa75c21554d17f9df4f240f3af48c0b.jpg";